import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { ArrowRightLeft } from "lucide-react";

export const ProtectedInformation = ({
  label,
  value,
  onClick,
}: {
  value: React.ReactNode;
  label: string;
  onClick?: () => void;
}) => {
  const { t } = useTranslation("boExpeditionForm");
  return (
    <div className="flex w-full flex-row items-center justify-between gap-2">
      <p className="text-base font-medium text-gray-900">
        {t("informationDisplay.labelWithColon", { label })}
      </p>
      <div className="flex flex-row items-center gap-2">
        {value}
        {onClick && (
          <Button variant="ghost" onClick={onClick} type="button">
            <ArrowRightLeft />
          </Button>
        )}
      </div>
    </div>
  );
};

export const InformationDisplay = ({
  label,
  value,
  bold,
}: {
  label: string;
  value: string;
  bold?: boolean;
}) => {
  const { t } = useTranslation("boExpeditionForm");
  return (
    <div className="flex flex-row items-start gap-2">
      <p className={cn("w-fit text-sm whitespace-nowrap text-gray-900", bold && "font-bold")}>
        {t("informationDisplay.labelWithColon", { label })}
      </p>
      <p className={cn("text-sm text-gray-900", bold && "font-bold")}>{value}</p>
    </div>
  );
};
